if (!customElements.get('product-description-tabs')) {
  class ProductDescriptionTabs extends HTMLElement {
    constructor() {
      super();
      this.tabItems = this.querySelectorAll('.--tab-item');
      this.tabContents = this.querySelectorAll('.--tab-content');
      this.init();
    }

    init() {
      // Set the first tab as active by default
      if (this.tabItems.length > 0) {
        this.tabItems[0].classList.add('--is-active');
      }

      this.tabItems.forEach((item) => {
        item.addEventListener('click', this.handleTabClick.bind(this));
      });
    }

    handleTabClick(event) {
      const clickedItem = event.currentTarget;
      const tabIndex = clickedItem.dataset.tabIndex;

      clickedItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

      // Remove --is-active from all tab items
      this.tabItems.forEach((item) => {
        item.classList.remove('--is-active');
      });

      // Add --is-active to the clicked item
      clickedItem.classList.add('--is-active');

      // Hide all tab contents
      this.tabContents.forEach((content) => {
        content.style.display = 'none';
      });

      // Show the corresponding tab content
      const activeContent = this.querySelector(`.--tab-content[data-tab-index="${tabIndex}"]`);
      if (activeContent) {
        activeContent.style.display = 'block';
      }
    }
  }

  customElements.define('product-description-tabs', ProductDescriptionTabs);
}